import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

import MainHeader from "../../shared/MainHeader";
import ContactsTable from "../../components/ContactsTable";
import ButtonCommon from "../../shared/ButtonCommon";

import { GET } from "../../api/ApiService";
import { toast } from "react-toastify";
import AddEditContacts from "../../components/AddEditContacts";
import { storeContactData } from "../../slices/contactSlice";
import { useDispatch } from "react-redux";

const Contacts = () => {
  const DEFAULT_PAGE = 0;
  const DEFAULT_ROWS_PER_PAGE = 100;
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [contactData, setContactData] = useState();
  const [totalContactData, setTotalContactData] = useState();

  useEffect(() => {
    getContactList();
  }, []);

  const getContactList = async (
    page = DEFAULT_PAGE,
    rowsPerPage = DEFAULT_ROWS_PER_PAGE,
  ) => {
    const safePage = Number.isFinite(page) ? page : DEFAULT_PAGE;
    const safeRowsPerPage = Number.isFinite(rowsPerPage)
      ? rowsPerPage
      : DEFAULT_ROWS_PER_PAGE;

    try {
      const response = await GET(
        `contact/fetchAll?limit=${safeRowsPerPage}&page=${
          safePage + 1
        }&visibility=public`
      );
      setContactData(response.data);
      setTotalContactData(response?.total);
    } catch (err) {
      console.error("Error fetching activity list:", err?.response?.data);
      toast.error(err?.response?.data?.message);
    }
  };

  const newContactHandler = () => {
    dispatch(storeContactData(null));
    setOpenDialog(true);
  };

  const closeDialogHandler = () => {
    setOpenDialog(false);
  };

  return (
    <Box>
      <MainHeader headingText={"Contacts"} />

      <ButtonCommon btnClicked={newContactHandler}>
        Add new contact
      </ButtonCommon>

      <ContactsTable
        contactData={contactData}
        totalContactData={totalContactData}
        setContactData={setContactData}
        setTotalContactData={setTotalContactData}
        getContactList={getContactList}
        visibility="public"
      />

      <AddEditContacts
        openDialog={openDialog}
        closeDialogHandler={closeDialogHandler}
        getContactList={getContactList}
      />
    </Box>
  );
};

export default Contacts;
